import React, { useState, useEffect } from "react";
import AwordImg1 from "../assets/Img/award-1.jpg";
import Slider from "react-slick";
import { FaRightLong, FaLeftLong } from "react-icons/fa6";
import { Fade } from "react-bootstrap";
import axios from "axios";

const AwordSlider = () => {
  const [content, setContent] = useState([]);

  useEffect(() => {

    axios.get(`${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/get/allcertification`)
      .then((res) => {
        console.log(res)
        setContent(res.data);

      })

      .catch((err) =>
        console.log(err)
      )
  }, [])
  const [count, setCount] = useState(1);
  const handleInc = () => {
    if (count == content?.length) {
      setCount(1)
    }
    else {
      setCount(count + 1)
    }
  }
  const handleDec = () => {
    if (count == 1) {
      setCount(content.length)
    }
    else {
      setCount(count - 1)
    }
  }
  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="nextArrowAword">
        <div className="slider-btn-group w-100">
          <div className="slider-btn next-1" onClick={(e) => {
            onClick(e)
            handleInc();
          }}>

            <FaRightLong className="rightLeftIcon" />
          </div>
        </div>
      </div>
    );
  };
  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="slider-btn-area pervArrowAword">
        <div className="slider-btn-group w-100">
          <div class="slider-btn-group w-100" onClick={(e) => {
            onClick(e)
            handleDec()
          }}>
            <div class="slider-btn prev-1">
              <FaLeftLong className="rightLeftIcon" />

            </div>
          </div>
        </div>
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  return (
    <React.Fragment>
      <div className="home4-award-section">
        <div className="container-lg container-fluid">
          <div className="row mb-60">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>

                  Certificates and Awards
                </h2>
                <div className="dash-and-paragraph three">

                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-2  d-lg-flex d-none">
              <div className="franctional-pagi6">
                <div className="franctional-pagi6 swiper-pagination-fraction swiper-pagination-horizontal">
                  <span className="swiper-pagination-current">{count}</span> /{" "}
                  <span className="swiper-pagination-total">{content?.length}</span>
                </div>
              </div>
            </div>
            <div className="col-xl-10">
              <Slider {...settings}>
                {content?.map((data, index) => (
                  <div className="home4-award-slider-wrap" key={index}>
                    <div className="row g-lg-4 gy-5">
                      <div className="col-md-4 d-flex align-items-center">
                        <div className="award-content">
                          <h2>{data.categoryName}</h2>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 333 134"
                            fill="none"
                          >
                            <path
                              d="M22.3329 3C22.3329 4.47276 23.5268 5.66667 24.9995 5.66667C26.4723 5.66667 27.6662 4.47276 27.6662 3C27.6662 1.52724 26.4723 0.333333 24.9995 0.333333C23.5268 0.333333 22.3329 1.52724 22.3329 3ZM24.9998 112L25.1494 112.477L25.1571 112.475L25.1647 112.472L24.9998 112ZM24.9999 131L20.285 127.668L19.7568 133.417L24.9999 131ZM331.435 4.94405L331.27 4.47202L331.435 4.94405ZM24.9995 3.5H331.105V2.5H24.9995V3.5ZM331.27 4.47202L24.8349 111.528L25.1647 112.472L331.6 5.41607L331.27 4.47202ZM24.8501 111.523C18.739 113.44 13.4156 115.362 9.36195 117.221C7.33543 118.15 5.61514 119.068 4.26847 119.969C2.93072 120.863 1.9208 121.766 1.36259 122.678C0.786949 123.619 0.67813 124.604 1.22066 125.539C1.73254 126.422 2.77982 127.176 4.29278 127.839C7.33352 129.17 12.5855 130.267 20.4687 131.086L20.572 130.091C12.6991 129.274 7.58161 128.187 4.69384 126.923C3.24255 126.287 2.43581 125.641 2.08569 125.037C1.76621 124.487 1.78741 123.9 2.21557 123.2C2.66116 122.472 3.52883 121.666 4.82424 120.8C6.11074 119.94 7.77918 119.046 9.77874 118.13C13.7773 116.296 19.0554 114.389 25.1494 112.477L24.8501 111.523ZM331.105 3.5C331.668 3.5 331.802 4.28631 331.27 4.47202L331.6 5.41607C333.195 4.85893 332.794 2.5 331.105 2.5V3.5Z"
                              fill="#2F2F2F"
                            />
                          </svg>
                          <ul>
                            <li>{data.year}</li>
                            <li>{data.name}</li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-8 mt-2 mt-sm-5 ">
                        <div className="award-img">
                          <a
                            href={`${process.env.REACT_APP_GRIPHOLD_API_URL}/${data.image}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${process.env.REACT_APP_GRIPHOLD_API_URL}/${data.image}`}
                              alt="Award One"
                              style={{ cursor: 'pointer' }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}



              </Slider>

            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AwordSlider;
